export default () => {
    const scriptExists = !!(window.AccessiBe || window.acsb || window.acsbJS);
    if (!scriptExists){
        const script = document.createElement('script');
        const element = document.getElementsByTagName('body')[0];
        script.src = 'https://acsbap.com/apps/app/assets/js/acsb.js';
        script.async = true;
        script.defer = true;
        (typeof element === 'undefined' ? document.getElementsByTagName('html')[0] : element).appendChild(script);
        script.onload = function() {
            window.acsbJS.init({
                statementLink: '',
                feedbackLink: '',
                footerHtml: '',
                hideMobile: false,
                hideTrigger: false,
                language: 'en',
                position: 'right',
                leadColor: '#146FF8',
                triggerColor: '#146FF8',
                triggerRadius: '50%',
                triggerPositionX: 'right',
                triggerPositionY: 'bottom',
                triggerIcon: 'default',
                triggerSize: 'medium',
                triggerOffsetX: 20,
                triggerOffsetY: 20,
                mobile: {
                    triggerSize: 'small',
                    triggerPositionX: 'right',
                    triggerPositionY: 'bottom',
                    triggerOffsetX: 0, triggerOffsetY: 0,
                    triggerRadius: '50%'
                }
            });
        };
    }
};
